<script lang="ts">
  import { Button } from '@agapi/ui/button';
  import { Section } from '@agapi/ui/section';
  import { grid } from '@agapi/ui/panda/patterns';
  import { css } from '@agapi/ui/panda/css';

  import { Medium as ProductCardMedium } from '../../product-card';
  import { useCollectionContext } from '../../../contexts';

  import * as m from '$lib/parachute/messages';

  const collectionStore = useCollectionContext();
</script>

<Section>
  <div
    class={grid({
      columns: {
        base: 2,
        md: 4
      },
      gap: '4'
    })}
  >
    {#each collectionStore.content.products as product}
      {#key product.variants[0].sku}
        <ProductCardMedium
          product={product.variants[0]}
          buttonLabel={m.addToCart()}
        />
      {/key}
    {/each}
  </div>

  <div
    class={css({
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center'
    })}
  >
    {#if collectionStore.content.products.length < collectionStore.content.count}
      <Button onclick={() => collectionStore.load({ incrementLoad: true })}>{m.loadMore()}</Button>
      <span class={css({ mt: '3', fontSize: 'sm', color: 'text.subdued', sm: { fontSize: 'md' } })}>
        {m.displayingXOfYProducts({ value: collectionStore.content.products.length, total: collectionStore.content.count })}
      </span>
    {/if}
  </div>
</Section>
